import "core-js/modules/es6.array.find";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.array.find-index";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import uuid from '../utils/uuid';
import { normalizeLocation } from '../utils/history';
import invariant from 'invariant';
/**
 * Initial state of whereabouts redux store
 * @type {Object}
 */

var location = normalizeLocation(window.location);
var initialId = uuid();
export var initialState = {
  current: initialId,
  history: [initialId],
  locations: _defineProperty({}, initialId, {
    id: initialId,
    key: 'init',
    path: location.path,
    hash: location.hash,
    query: location.query
  })
};
export var REDUX_PUSH = 'whereabouts/PUSH';
export var REDUX_REPLACE = 'whereabouts/REPLACE';
export var REDUX_GO = 'whereabouts/GO';
/**
 * Main reducer for whereabouts actions
 * @param  {Object|undefined} state
 * @param  {Object} action
 * @return {Object}
 */

export function reducer(state, action) {
  if (!state) {
    return initialState;
  }

  switch (action.type) {
    // Push new history item
    case REDUX_PUSH:
      // Remove the history after the current location
      var currIndex = state.history.findIndex(function (id) {
        return id === state.current;
      });

      var newHistory = _toConsumableArray(state.history);

      newHistory.length = currIndex + 1; // Create uuid for new route

      var pushId = uuid();
      return _objectSpread({}, state, {
        current: pushId,
        history: [].concat(_toConsumableArray(newHistory), [pushId]),
        locations: _objectSpread({}, state.locations, _defineProperty({}, pushId, _objectSpread({
          id: pushId
        }, action.payload)))
      });

    case REDUX_REPLACE:
      var replaceId = uuid();
      return _objectSpread({}, state, {
        current: replaceId,
        history: state.history.map(function (id) {
          return id === state.current ? replaceId : id;
        }),
        locations: _objectSpread({}, state.locations, _defineProperty({}, replaceId, _objectSpread({
          id: replaceId
        }, action.payload)))
      });

    case REDUX_GO:
      invariant(action.payload && action.payload.toKey, 'You need to define the new location key in \'toKey\' of the action payload!');
      var newId = state.history.find(function (id) {
        return state.locations[id].key === action.payload.toKey;
      });
      var locations = state.locations;
      var history = state.history; // NOTE: in case of the forward event that triggers the POP action
      // with the key of the target hostory entry, if the page has been
      // refreshed since this entry was visited it will cause whereabouts
      // to break cause it cannot find the entry in the state... so we cannot
      // assume the key will always be there, so instead we just push the given
      // location!

      if (!newId) {
        var _currIndex = state.history.findIndex(function (id) {
          return id === state.current;
        });

        var _newHistory = _toConsumableArray(state.history);

        _newHistory.length = _currIndex + 1; // Create uuid for new route

        newId = uuid();
        history = [].concat(_toConsumableArray(_newHistory), [newId]);
        locations = _objectSpread({}, locations, _defineProperty({}, newId, action.payload.location));
      }

      return _objectSpread({}, state, {
        current: newId,
        history: history,
        locations: locations
      });
    // Fallback

    default:
      return state;
  }
}